<div
  class="select"
  [ngClass]="{ 'select--disabled': readonly || disabled }"
>
  <div>

    <div
      class="select__control"
      [ngClass]="{
        'select__control--open': showOptions
      }"
    >
      <div
        class="select__selected"
        (click)="toggleOptions()"
      >
        <span class="selected__label">{{ selectValue }}</span>
        <img
          class="selected__icon"
          alt="Select arrow icon"
          mfpLazyImage
          lazySrc="assets/icons/arrow-small.svg"
          [ngClass]="{ 'selected__icon--open': showOptions }"
        />
      </div>
      <ng-container *ngIf="showOptions">
        <ul class="select__options">
          <li
            *ngFor="let option of options"
            class="select__option"
            (click)="selectOption(option)">{{ option.key }}
          </li>
        </ul>
      </ng-container>
    </div>
  </div>
</div>
